var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { classes } from '../../helpers';
import { Row, Col } from '../../';
import { useTheme } from '../Theme/Theme';
import { style } from './style';
import { Text } from '../Text';
function useCombinedRefs(...refs) {
    const targetRef = React.useRef();
    React.useEffect(() => {
        refs.forEach((ref) => {
            if (!ref)
                return;
            if (typeof ref === 'function') {
                ref(targetRef.current);
            }
            else {
                ref.current = targetRef.current;
            }
        });
    }, [refs]);
    return targetRef;
}
export const BaseInputComponent = React.forwardRef((props, ref) => {
    const [focused, updateFocused] = React.useState(false);
    const { error, label, onFocus, onBlur, after, before, required, hint, containerStyle, containerClassName, children, borderless } = props, rest = __rest(props, ["error", "label", "onFocus", "onBlur", "after", "before", "required", "hint", "containerStyle", "containerClassName", "children", "borderless"]);
    const input = React.useRef(null);
    const combinedRef = useCombinedRefs(ref, input);
    const isInputActive = () => {
        var _a, _b, _c;
        return !!(focused ||
            props.value ||
            props.defaultValue ||
            ((_a = input.current) === null || _a === void 0 ? void 0 : _a.value) ||
            ((_b = input.current) === null || _b === void 0 ? void 0 : _b.defaultValue) ||
            props.placeholder ||
            ((_c = input.current) === null || _c === void 0 ? void 0 : _c.placeholder) ||
            props.before);
    };
    const ShouldHover = () => {
        return !(focused || error);
    };
    const theme = useTheme();
    const css = style({
        theme,
        error: !!error,
        label: !!label,
        active: isInputActive(),
        borderless: borderless || false,
        disabled: props.disabled || false,
        before: !!before,
        hover: ShouldHover(),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { style: containerStyle, alignItems: "center", gutter: [0, 0], className: classes(containerClassName, css.container, 'sha-el-input'), wrap: "wrap" },
            label && (React.createElement("label", { key: "label", className: classes(css.label, 'label') },
                label,
                " ",
                required && React.createElement("span", { style: { color: 'red' } }, "*"))),
            before && (React.createElement(Col, { style: { paddingLeft: (!borderless && '5px') || undefined }, flex: "0 1 auto", className: classes(css.seudo, 'seudo') }, before)),
            React.createElement(Col, { flex: "1 0 auto" }, React.cloneElement(children, Object.assign({ className: css.input, required, ref: combinedRef, onFocus: (e) => {
                    onFocus && onFocus(e);
                    updateFocused(true);
                }, onBlur: (e) => {
                    onBlur && onBlur(e);
                    updateFocused(false);
                } }, rest))),
            after && (React.createElement(Col, { style: { paddingRight: (!borderless && '5px') || undefined }, flex: "0 1 auto", className: classes(css.seudo, 'seudo') }, after)),
            React.createElement("fieldset", { className: css.fieldset },
                React.createElement("legend", { className: css.legend },
                    React.createElement("span", null, label)))),
        (error !== undefined || hint !== undefined) && (React.createElement(Row, { justifyContent: "flex-end", gutter: [0, `0 ${borderless ? '0' : before ? '5px' : '14px'}`], className: classes(css.help, 'help') },
            error && (React.createElement(Col, { flex: "1 0 auto" },
                React.createElement(Text, { variant: "label", className: `${css.error}` }, error))),
            hint && (React.createElement(Col, { flex: "0 1 auto" },
                React.createElement(Text, { variant: "label", className: `${css.hint}` }, hint)))))));
});
//# sourceMappingURL=BaseInputComponent.js.map